import React, { useContext, useEffect, useState } from 'react';
import 'firebase/analytics';
import 'firebase/firestore';
import { AuthContext } from '../contexts/AuthContext';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import image from '../img/bg6.jpg';
import Typography from '@material-ui/core/Typography';
import { CardHeader } from '../components/Card/CardHeader';
import { CardBody } from '../components/Card/CardBody';
import { Card } from '../components/Card/Card';
import { Alert } from '@material-ui/lab';
import Button from '@material-ui/core/Button';
import { db } from '../firebase';
import { AutoCompleteInput } from '../components/AutoCompleteInput/AutoCompleteInput';
import Footer from '../core/Layout/Footer';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    alignText: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100%',
    color: 'white',
  },
  appBar: {
    height: '100px',
  },
  title: {
    color: 'white',
    fontFamily: '["Roboto", "Helvetica", "Arial", sans-serif]',
    margin: '100px auto',
  },
  card: {
    alignContent: 'center',
    justifyContent: 'center',
  },
  heading: {
    color: 'white',
    fontFamily: '["Roboto", "Helvetica", "Arial", sans-serif]',
    fontWeight: 100,
    textAlign: 'left',
  },
  subHeading: {
    color: 'rgba(255,255,255,.62)',
    fontFamily: '["Roboto", "Helvetica", "Arial", sans-serif]',
    marginTop: '10px',
    fontWeight: 100,
    fontSize: '16px',
    textAlign: 'left',
  },
  formContent: {
    margin: '20px 0',
  },
  formInput: {
    margin: '10px',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  gridItem: {
    marginTop: '20px',
  },
}));
export const Dashboard = () => {
  const classes = useStyles();
  const { currentUser } = useContext(AuthContext);
  const [message, setErrorMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [membersInfo, setMembersInfo] = useState([]);
  const [profiles, setProfiles] = useState<any>([]);
  const [adminOption, setAdminOption] = useState<any>({});

  const adminHandler = async () => {
    await db.collection('profile').doc(adminOption.id).update({ role: 'admin' });
  };

  const moderatorHandler = async () => {
    await db.collection('profile').doc(adminOption.id).update({ role: 'moderator' });
  };

  useEffect(() => {
    const membership = async () => {
      const profileList = [];
      const profiles = await db.collection('profile').get();
      if (profiles.empty) {
        console.log('No matching documents in profiles collection.');
        return;
      }
      profiles.forEach((doc) => {
        profileList.push({
          name: `${doc.data().firstName} ${doc.data().lastName}`,
          dp: doc.data().dp_url,
          positions: doc.data().positions,
          email: doc.data().email,
          id: doc.id,
        });
      });
      setProfiles(profileList);
    };
    membership().then();
  }, []);

  return (
    <Grid>
      <Grid item className={classes.container}>
        <div className={classes.appBar} />
        <Grid container component="main" className={classes.card}>
          {/*ADMIN*/}
          <Grid item xs={10} md={3}>
            <Card elevation="2">
              <CardHeader>
                <Typography variant="h6" className={classes.heading}>
                  Add an admin
                </Typography>
                <Typography variant="h6" className={classes.subHeading}>
                  Enter a name to make it an admin
                </Typography>
              </CardHeader>
              <CardBody>
                <div style={{ marginLeft: '10px' }}>
                  <AutoCompleteInput
                    options={profiles}
                    optionHandler={(option) => setAdminOption(option)}
                  />
                </div>
                {showAlert && <Alert severity="error">{message}</Alert>}
                <Button
                  disabled={loading}
                  onClick={adminHandler}
                  fullWidth={true}
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  ADD
                </Button>
              </CardBody>
            </Card>
          </Grid>

          <Grid item xs={12} />

          {/*MODERATOR*/}
          <Grid item xs={10} md={3} className={classes.gridItem}>
            <Card elevation="2">
              <CardHeader>
                <Typography variant="h6" className={classes.heading}>
                  Add a moderator
                </Typography>
                <Typography variant="h6" className={classes.subHeading}>
                  Enter a name to make it a moderator
                </Typography>
              </CardHeader>
              <CardBody>
                <div style={{ marginLeft: '10px' }}>
                  <AutoCompleteInput
                    options={profiles}
                    optionHandler={(option) => setAdminOption(option)}
                  />
                </div>
                {showAlert && <Alert severity="error">{message}</Alert>}
                <Button
                  disabled={loading}
                  onClick={moderatorHandler}
                  fullWidth={true}
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  ADD
                </Button>
              </CardBody>
            </Card>
          </Grid>
        </Grid>
      </Grid>
      {/*Footer*/}
      <Grid item sm={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};
